/**
 * Money and weight are 2dp throughout SmartSend, and both reach the courier as declaration values, so
 * float dust must never survive into one.
 *
 * Its own leaf module rather than living in allocate.ts because QuantityValueSummary needs it too, and
 * allocate.ts imports QuantityValueSummary - importing back the other way would be a cycle.
 */
export const round2 = (n: number): number => Math.round(n * 100) / 100;
